<template>
  <el-form-item
    label-width="100px"
    :class="{'required': data.isRequired,}"
    :required="data.isRequired&&data.controlType !== 'InputUploadImg'"
    style="text-align:left;margin-left:-110px"
  >
  <!-- 单选/多选/排序 -->
  <div v-if="whichtempleteId">
    <div style="clear:both">
      <el-form :model="formData" ref="formV1" :show-message="false">
        <div v-for="(d,j) in formData.controls" :key="d.tab">
          <!--可选项数据加载-->
          <el-form-item
            label-width="110px"
            style="display:inline-block;margin-bottom:10px;"
            :label="d.tab"
            :required="data.isRequired"
            :class="{'v-check': data.isRequired}"
          >
            <el-input v-model="d.content" style="width:650px" type="textarea" maxlength="100" show-word-limit></el-input>
            <el-upload
              style="display:inline-block"
              class="picture-uploader"
              accept="image/jpg, image/jpeg, image/png"
              :action="commonServer.uploadFile"
              :headers="{Authorization:token}"
              :show-file-list="false"
              :on-error="handleFileError"
              :on-success="(v)=>{handleFileSuccess(j,v)}"
              :before-upload="(v)=>{beforeUpload(v,j)}"
            >
              <i v-if="!d.fileUrl" slot="default" class="el-icon-picture picture-uploader-icon"></i>
              <div v-else class="upload-item">
                <img @click.stop="openImageBox(j)" :src="d.fileUrl" class="picture" />
                <a class="btn-delete" href="javascript:void(0)" @click.stop="handleFileRemove(d)"><i class="el-icon-circle-close"></i></a>
              </div>
            </el-upload>
          </el-form-item>
          <!--删除可选项-->
          <div class="el-i-minus" v-if="formData.controls.length>4">
            <el-button type="primary" size="mini" @click="handleMinus(d,j)">删除</el-button>
          </div>
        </div>
        <!--新增可选项-->
        <div class="el-i-plus" style="padding-left:90px;" v-if="formData.controls.length<6">
          <i class="el-icon-plus" @click="handlePlus"></i>
        </div>
      <div class="answer_area">
        <el-form-item
            label-width="110px"
            style="display:inline-block"
            :label="'正确答案'"
            :required="data.isRequired"
          >
        <!--多选-->
        <el-checkbox-group v-if="data.checked=='multiple'" v-model="initCV.multipleCV" @change="checkChange" size="medium" style="display: inline-block;">
          <el-checkbox-button class="choose-box" v-for="(item,i) in formData.controls" :key="i" :label="item.tab">{{item.tab}}</el-checkbox-button>
        </el-checkbox-group>
        <!--单选-->
        <el-radio-group v-else-if="data.checked=='single'" v-model="data.controlValue" size="medium">
          <el-radio-button
            v-for="(item,i) in formData.controls"
            :key="i"
            :label="item.tab"
            :value="item.tab"
          ></el-radio-button>
        </el-radio-group>
        <!-- 排序 -->
        <div v-else-if="data.checked=='sort'" style="display:inline-block">
          <el-select
            style="width: 120px;margin-right:10px" clearable
            v-for="(d,j) in formData.controls"
            :key="d.tab"
            v-model="data.controlValue[j]"
            placeholder="请选择"
            @change="selectChange"
            >
            <el-option v-for="(item,i) in formData.controls" :disabled="isOptionDisabled(item.tab)"
            :key="i" :label="item.tab" :value="item.tab"></el-option>
          </el-select>
        </div>
      </el-form-item>
    </div>
    </el-form>
  </div>
  </div>
  <!-- 判断/填空 -->
  <div v-else>
    <!-- 判断题 -->
    <el-form :model="formInline" v-if="data.checked=='judge'">
      <el-form-item
        label-width="110px"
        style="display:inline-block;"
        :label="'正确答案'"
        :required="data.isRequired"
        >
        <el-radio-group v-model="data.controlValue" size="medium">
          <el-radio-button
          v-for="(item,i) in formData.controls"
          :key="i"
          :label="item.content"
          >{{item.tab}}</el-radio-button>
      </el-radio-group>
      </el-form-item>
    </el-form>
      <!-- 填空题 -->
      <el-form :model="formInline" v-if="data.checked=='gap'">
        <div v-for="(d,j) in formData.controls" :key="d.tab">
          <!--可选项数据加载-->
          <el-form-item
            label-width="110px"
            style="display:inline-block;margin-bottom:10px;"
            :label="d.tab"
            :required="data.isRequired"
            :class="{'v-check': data.isRequired}"
          >
            <el-input v-model="d.content" style="width:650px" type="textarea" maxlength="50" show-word-limit></el-input>
          </el-form-item>
          <!--删除可选项-->
          <div class="el-i-minus" v-if="formData.controls.length>1">
            <el-button type="primary" size="mini" @click="handleMinus(d,j)">删除</el-button>
          </div>
        </div>
        <!--新增可选项-->
        <div class="el-i-plus" style="padding-left:90px;">
          <i class="el-icon-plus" @click="handlePlus"></i>
        </div>
      </el-form>
  </div>
  <image-box ref="imageBox"></image-box>
  </el-form-item>
</template>

<script>
import letterFormat from '@/mixin/letterFormat.js'
import getImgUrl from '@/mixin/getImgUrl.js'
import { commonServer } from '@/api/api'
import imageBox from '../imageBox';
export default {
  name: 'inputUploadImg',
  inject: ['formData'],
  props: {
    data: {
      type: Object,
      required: true
    },
    keyName: String
  },
  mixins: [ getImgUrl, letterFormat ],
  components: { imageBox },
  computed: {
    whichtempleteId () {
      const tpid = this.formData.templateId
      if (tpid === 1 || tpid === 2  || tpid === 4 ) {
        return true
      }
      return false
    }
  },
  watch: {
    'data.controlValue'(newVal) {
      this.INITresanswer()
    }
  },
  data () {
    return {
      commonServer,
      initCV: {
        multipleCV: []
      },
      formInline: {},
      token: window.localStorage.getItem('token')
    }
  },
  mounted () {
    console.log('--------------也加载')
  },
  methods: {
    handleFileSuccess (i, res, file) {
      if (res.code === '1') {
        this.$message.error(res.message);
      } else {
        this.$set(this.formData.controls, i, { ...this.formData.controls[i], key: res.data.fileKey, fileUrl: res.data.fileUrl})
      }
    },
    INITresanswer () {
      if (this.formData.templateId === 2 && this.data.controlValue.length) {
        this.initCV.multipleCV = this.data.controlValue.split(',')
      }
      if (this.formData.templateId === 2 && !this.data.controlValue.length) {
        this.initCV.multipleCV = []
      }
    },
    handleFileError (err, file, fileList) {
      this.$message.error(err);
    },
    beforeUpload (file, i) {},
    checkChange (v) {
      this.data.controlValue = v.sort().join(',')
    },
    selectChange (v) {},
    // 判断某个选项是否已被选择，若已选择则禁用
    isOptionDisabled(value) {
      return this.data.controlValue.includes(value);
    },
    handleFileRemove (file) {
      let idx = this.formData.controls.findIndex(it => it.key === file.key);
      if (idx !== -1) {
        this.formData.controls[idx].key = '';
        this.formData.controls[idx].fileUrl = '';
      }
    },
    handlePlus () {
      if (this.whichtempleteId) {
        let letter = this.getLetterFromNumber(this.formData.controls.length);
        this.formData.controls.push({
          tab: letter,
          content: '',
          enclosure: ''
        })
        return
      }
      let letter = this.getLetterFromText(this.formData.controls.length);
      this.formData.controls.push({
        tab: letter,
        content: '',
        enclosure: ''
      })
    },
    handleMinus (item, i) {
      // 删除某一问题
      if (this.whichtempleteId) {
        this.formData.controls.splice(i, 1);
        // 重排问题
        this.formData.controls.forEach((v, i) => {
          let letter = this.getLetterFromNumber(i);
          this.$set(this.formData.controls, i, { ...v, tab: letter });
        })
      } else {
        this.formData.controls.splice(i, 1);
        // 重排问题
        this.formData.controls.forEach((v, i) => {
          let letter = this.getLetterFromText(i);
          this.$set(this.formData.controls, i, { ...v, tab: letter });
        })
      }
      this.data.controlValue = []
      // 如答案选项被删 则重置正确答案
      // let v = this.data.controlValue;
      // if (v) {
      //   let arr = this.formData.controls.filter(d => { return d.tab === v });
      //   if (!arr.length) this.data.controlValue = '';
      // }
    },
    openImageBox (index) {
      if (this.$refs.imageBox) {
        let imageList = []
        for (let i = 0, length = this.formData.controls.length; i < length; i++) {
          imageList.push({ url: `${this.formData.controls[i].fileUrl}` })
        }
        this.$refs.imageBox.$emit('open', {
          imageList: imageList,
          index: index
        })
      }
    }
  }
}

</script>
<style scoped lang='scss'>
.upload-item {
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
  .btn-delete {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 18px;
    line-height: 20px;
    color: grey;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
    cursor: pointer;
  }
}
.picture {
  width: 30px;
  height: 30px;
  margin: 0 10px;
  position: relative;
  top: 8px;
  border: 1px #ddd solid;
}

.picture-uploader-icon {
  width: 30px;
  height: 30px;
  margin: 0 10px;
  font-size: 30px;
  position: relative;
  top: 5px;
}
.answer_area .right-text {
  width: 107px;
  padding-right: 8px;
  display: inline-block;
  text-align: right;  
}
</style>



// WEBPACK FOOTER //
// src/components/form/inputUploadImg.vue